import React, {
    useEffect, useState, useCallback, useContext,
    useMemo
} from 'react';
import { withRouter } from 'react-router-dom';
import { Loader } from '@jutro/components';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { useAuthentication } from 'gw-digital-auth-react';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
import { withApplicationPropertyContext } from 'tdic-components-platform-react';
import { PolicyService } from 'gw-capability-policy';
// eslint-disable-next-line import/no-extraneous-dependencies
import { UsersProfileDetailsService } from 'gw-capability-profileinfo';
import metadata from './PLRenewalSurveyQuestionnaire.metadata.json5';
import buildPayload from './PayloadBuilder';
import styles from '../../Survey.module.scss';
import messages from '../../Survey.messages';

function PLRenewalSurveyQuestionnaire({ history, tncTransactionTypesSubTypes, termData: terms }) {
    const translator = useContext(TranslatorContext);
    const { authHeader, user_name: userName } = useAuthentication();
    const auth = useAuthentication();
    const [isLoading, setLoading] = useState(true);
    const [formSubmitted, updateFormSubmitted] = useState(false);
    const [renewalPolicy, setRenewalPolicy] = useState();
    const [isDentalSpecialtyCompleted, setIsDentalSpecialtyCompleted] = useState(null);
    const [dentalSpecialty, setDentalSpecialty] = useState('');
    const [specialtySchoolAttended, setSpecialtySchoolAttended] = useState('');
    const [yearSpecialtyCompleted, setYearSpecialtyCompleted] = useState('');
    const [administeredAnestheticModalities, setAdministeredAnestheticModalities] = useState([]);
    const [othersAdministerAnesthetic, setOthersAdministerAnesthetic] = useState([]);
    const [isConsciousSedationAdministered, setIsConsciousSedationAdministered] = useState(null);
    const [specialistTypeAdministeringAnesthesia,
        setSpecialistTypeAdministeringAnesthesia] = useState([]);
    const [isConsciousSedationInOfficeAdministered,
        setIsConsciousSedationInOfficeAdministered] = useState(null);
    const [ivImSedationAdministeredName, setIvImSedationAdministeredName] = useState('');
    const [ivImSedationLicenseNumber, setIvImSedationLicenseNumber] = useState('');
    const [ivImSedationSpecialty, setIvImSedationSpecialty] = useState('');
    const [isGeneralAnesthesiaAdministered, setIsGeneralAnesthesiaAdministered] = useState(null);
    const [generalAnesthesiaAdministeredName, setGeneralAnesthesiaAdministeredName] = useState('');
    const [generalAnesthesiaLicenseNumber, setGeneralAnesthesiaLicenseNumber] = useState('');
    const [generalAnesthesiaSpecialty, setGeneralAnesthesiaSpecialty] = useState('');
    const [renewalAcknowledged, updateRenewalAcknowledged] = useState(false);
    const [otherSpecialistType, setOtherSpecialistType] = useState('');
    const [consciousSedationAdministeredName, setConsciousSedationAdministeredName] = useState('');
    const [consciousSedationLicenseNumber, setConsciousSedationLicenseNumber] = useState('');
    const [consciousSedationSpecialty, setConsciousSedationSpecialty] = useState('');
    const [generalAnesthesiaDetailsAdministeredName, setGeneralAnesthesiaDetailsAdministeredName] = useState('');
    const [generalAnesthesiaDetailsLicenseNumber, setGeneralAnesthesiaDetailsLicenseNumber] = useState('');
    const [generalAnesthesiaDetailsSpecialty, setGeneralAnesthesiaDetailsSpecialty] = useState('');
    const [loggedUserContact, updateLoggedUserContact] = useState(null);
    const [userState, setUserState] = useState(null);

    useEffect(() => {
        UsersProfileDetailsService.getEffectiveUserContactSummary(
            authHeader
        ).then((contact) => {
            updateLoggedUserContact(contact);
        }).catch(() => {
            return history.push('/app-error');
        });

        UsersProfileDetailsService.getUserNotifications(authHeader).then((response) => {
            const item = _.find(response, { menuOption: 'PoliciesForAnestheticModalityQuestionnaire', available: true });
            const values = _.get(item, 'values', []);
            const policyNumbers = Array.isArray(values) ? values.filter(Boolean) : [];
            if (!_.isEmpty(policyNumbers)) {
                setRenewalPolicy(policyNumbers[0]);
                setLoading(false);
            }
            if (_.isEmpty(policyNumbers)) {
                setLoading(false);
                setRenewalPolicy(null);
            }
        });
    }, [authHeader, history]);

    useEffect(() => {
        if (loggedUserContact) {
            const state = _.get(loggedUserContact, 'accountContact.primaryAddress.state', null);
            setUserState(state);
        }
    }, [loggedUserContact]);

    const handleSaveAcceptance = useCallback((tncType, tncSubTypes) => {
        const reqOption = {
            Version: _.get(terms, 'Version', ''),
            acceptance: 1,
            Transaction_Detail: renewalPolicy.split('-')[0],
            Transaction_Type: _.get(tncType, 'id'),
            Transaction_SubTypes: tncSubTypes,
            email_Address: userName
        };
        PolicyService
            .saveUserTermsAndConditions(reqOption, authHeader);
    }, [terms, renewalPolicy, userName, authHeader]);

    const handleCloseClick = useCallback(() => {
        history.push('/home');
    }, [history]);

    const handleRenewalAgreeChange = useCallback((value) => {
        updateRenewalAcknowledged(value);
    }, []);

    const prepareRequest = useCallback(() => {
        const questions = buildPayload({
            renewalPolicy,
            authName: _.get(auth, 'name', ''),
            isDentalSpecialtyCompleted,
            dentalSpecialty,
            specialtySchoolAttended,
            yearSpecialtyCompleted,
            administeredAnestheticModalities,
            othersAdministerAnesthetic,
            isConsciousSedationAdministered,
            specialistTypeAdministeringAnesthesia,
            otherSpecialistType,
            isConsciousSedationInOfficeAdministered,
            ivImSedationAdministeredName,
            ivImSedationLicenseNumber,
            ivImSedationSpecialty,
            isGeneralAnesthesiaAdministered,
            generalAnesthesiaAdministeredName,
            generalAnesthesiaLicenseNumber,
            generalAnesthesiaSpecialty,
            consciousSedationAdministeredName,
            consciousSedationLicenseNumber,
            consciousSedationSpecialty,
            generalAnesthesiaDetailsAdministeredName,
            generalAnesthesiaDetailsLicenseNumber,
            generalAnesthesiaDetailsSpecialty
        });
        return {
            policyNumber: renewalPolicy,
            name: _.get(auth, 'name', ''),
            plQuestions: [],
            eplQuestions: [],
            SpecialtyAnestheticModality: questions
        };
    }, [
        auth, renewalPolicy, isDentalSpecialtyCompleted, dentalSpecialty, specialtySchoolAttended,
        yearSpecialtyCompleted, administeredAnestheticModalities, othersAdministerAnesthetic,
        isConsciousSedationAdministered, specialistTypeAdministeringAnesthesia, otherSpecialistType,
        isConsciousSedationInOfficeAdministered, ivImSedationAdministeredName,
        ivImSedationLicenseNumber,
        ivImSedationSpecialty, isGeneralAnesthesiaAdministered, generalAnesthesiaAdministeredName,
        generalAnesthesiaLicenseNumber, generalAnesthesiaSpecialty,
        consciousSedationAdministeredName, consciousSedationLicenseNumber,
        consciousSedationSpecialty, generalAnesthesiaDetailsAdministeredName,
        generalAnesthesiaDetailsLicenseNumber, generalAnesthesiaDetailsSpecialty
    ]);


    const handleSubmitClick = useCallback(() => {
        setLoading(true);
        const request = prepareRequest();
        PolicyService.sendSurveyResponse(authHeader, request)
            .then((response) => {
                updateFormSubmitted(response);
                setLoading(false);
                const tncType = _.find(tncTransactionTypesSubTypes, { transaction_Type: 'Survey' });
                const tncSubType = _.find(tncType.transactionSubTypes, { transaction_SubType: 'SpecialtyAnestheticModalitySurvey' });
                const subTypes = [tncSubType.id];
                handleSaveAcceptance(tncType, subTypes);
            })
            .catch(() => setLoading(false));
    }, [authHeader, handleSaveAcceptance, prepareRequest, tncTransactionTypesSubTypes]);

    useEffect(() => {
        if (!(othersAdministerAnesthetic.length >= 1 && !othersAdministerAnesthetic.includes('None'))) {
            setIsConsciousSedationAdministered(null);
        }
    }, [othersAdministerAnesthetic]);

    useEffect(() => {
        if (!specialistTypeAdministeringAnesthesia.includes('Other specialist')) {
            setOtherSpecialistType('');
        }
    }, [specialistTypeAdministeringAnesthesia]);

    useEffect(() => {
        if (isConsciousSedationAdministered !== true) {
            setSpecialistTypeAdministeringAnesthesia([]);
        }
    }, [isConsciousSedationAdministered]);

    useEffect(() => {
        if (isConsciousSedationAdministered !== false) {
            setIsConsciousSedationInOfficeAdministered(null);
        }
    }, [isConsciousSedationAdministered]);

    useEffect(() => {
        if (isConsciousSedationInOfficeAdministered !== true) {
            setIvImSedationAdministeredName('');
            setIvImSedationLicenseNumber('');
            setIvImSedationSpecialty('');
        }
    }, [isConsciousSedationInOfficeAdministered]);

    useEffect(() => {
        if (isConsciousSedationInOfficeAdministered !== false) {
            setIsGeneralAnesthesiaAdministered(null);
        }
    }, [isConsciousSedationInOfficeAdministered]);

    useEffect(() => {
        if (isGeneralAnesthesiaAdministered !== true) {
            setGeneralAnesthesiaAdministeredName('');
            setGeneralAnesthesiaLicenseNumber('');
            setGeneralAnesthesiaSpecialty('');
        }
    }, [isGeneralAnesthesiaAdministered]);

    useEffect(() => {
        if (isDentalSpecialtyCompleted !== true) {
            setDentalSpecialty('');
            setSpecialtySchoolAttended('');
            setYearSpecialtyCompleted('');
        }
    }, [isDentalSpecialtyCompleted]);

    useEffect(() => {
        if (!othersAdministerAnesthetic.includes('Conscious sedation (including IV or IM) in office')) {
            setConsciousSedationAdministeredName('');
            setConsciousSedationLicenseNumber('');
            setConsciousSedationSpecialty('');
        }
        if (!othersAdministerAnesthetic.includes('General anesthesia in office')) {
            setGeneralAnesthesiaDetailsAdministeredName('');
            setGeneralAnesthesiaDetailsLicenseNumber('');
            setGeneralAnesthesiaDetailsSpecialty('');
        }
    }, [othersAdministerAnesthetic]);

    const getPageTitleInfo = useCallback(() => {
        return _.isEmpty(renewalPolicy) ? translator(messages.renewalSurveyForm)
            : translator(messages.renewalSurveyFormWithPolicy, { policyNumber: renewalPolicy.split('-')[0] });
    }, [renewalPolicy, translator]);


    const buttonDisabled = useMemo(() => {
        if (!renewalAcknowledged) {
            return true;
        }
        if (renewalAcknowledged) {
            if (isDentalSpecialtyCompleted === null) return true;
            if (isDentalSpecialtyCompleted === true) {
                if (!dentalSpecialty || !specialtySchoolAttended || !yearSpecialtyCompleted) {
                    return true;
                }
            }
            if (administeredAnestheticModalities.length === 0) return true;
            if (othersAdministerAnesthetic.length === 0) return true;
            if (othersAdministerAnesthetic.length >= 1 && !othersAdministerAnesthetic.includes('None')) {
                if (isConsciousSedationAdministered === null) return true;
                if (isConsciousSedationAdministered === true) {
                    if (specialistTypeAdministeringAnesthesia.length === 0) return true;
                    if (specialistTypeAdministeringAnesthesia.includes('Other specialist') && !otherSpecialistType.trim()) {
                        return true;
                    }
                }
                if (isConsciousSedationAdministered === false) {
                    if (isConsciousSedationInOfficeAdministered === null) return true;
                    if (isConsciousSedationInOfficeAdministered === true) {
                        if (!ivImSedationAdministeredName || !ivImSedationLicenseNumber
                            || !ivImSedationSpecialty) {
                            return true;
                        }
                    }
                    if (isConsciousSedationInOfficeAdministered === false) {
                        if (isGeneralAnesthesiaAdministered === null) return true;
                        if (isGeneralAnesthesiaAdministered === true) {
                            if (!generalAnesthesiaAdministeredName
                                || !generalAnesthesiaLicenseNumber || !generalAnesthesiaSpecialty) {
                                return true;
                            }
                        }
                    }
                }
                if (othersAdministerAnesthetic.includes('Conscious sedation (including IV or IM) in office')) {
                    if (!consciousSedationAdministeredName
                        || !consciousSedationLicenseNumber || !consciousSedationSpecialty) {
                        return true;
                    }
                }
                if (othersAdministerAnesthetic.includes('General anesthesia in office')) {
                    if (!generalAnesthesiaDetailsAdministeredName
                        || !generalAnesthesiaDetailsLicenseNumber
                        || !generalAnesthesiaDetailsSpecialty) {
                        return true;
                    }
                }
            }
        }
        return false;
    }, [
        renewalAcknowledged, isDentalSpecialtyCompleted, administeredAnestheticModalities,
        othersAdministerAnesthetic, isConsciousSedationAdministered, dentalSpecialty,
        specialtySchoolAttended, yearSpecialtyCompleted, consciousSedationAdministeredName,
        consciousSedationLicenseNumber, consciousSedationSpecialty,
        generalAnesthesiaDetailsAdministeredName, generalAnesthesiaDetailsLicenseNumber,
        generalAnesthesiaDetailsSpecialty, specialistTypeAdministeringAnesthesia,
        otherSpecialistType, isConsciousSedationInOfficeAdministered,
        ivImSedationAdministeredName, ivImSedationLicenseNumber,
        ivImSedationSpecialty, isGeneralAnesthesiaAdministered, generalAnesthesiaAdministeredName,
        generalAnesthesiaLicenseNumber, generalAnesthesiaSpecialty,
    ]);
    const getConfirmationInfo = useCallback(() => {
        return _.isEmpty(renewalPolicy)
            ? translator(messages.confirmationSurvey)
            : translator(messages.confirmationSurveyWithPolicy, { policyNumber: renewalPolicy.split('-')[0] });
    }, [renewalPolicy, translator]);


    const handleChange = useCallback((id, value, type) => {
        if (type === 'checkboxgroup') {
            let newValue = Array.isArray(value) ? value : [value];
            if (id === 'administeredAnestheticModalities' || id === 'othersAdministerAnesthetic') {
                if (newValue.includes('None')) {
                    if (newValue[0] === 'None' && newValue.length > 1) {
                        newValue = newValue.filter((v) => v !== 'None');
                    } else {
                        newValue = ['None'];
                    }
                } else {
                    newValue = newValue.filter((v) => v !== 'None');
                }
            }
            switch (id) {
                case 'administeredAnestheticModalities':
                    setAdministeredAnestheticModalities(newValue);
                    break;
                case 'othersAdministerAnesthetic':
                    setOthersAdministerAnesthetic(newValue);
                    break;
                case 'specialistTypeAdministeringAnesthesia':
                    setSpecialistTypeAdministeringAnesthesia(newValue);
                    break;
                default:
                    break;
            }
        } else {
            switch (id) {
                case 'isDentalSpecialtyCompleted':
                    setIsDentalSpecialtyCompleted(value);
                    break;
                case 'dentalSpecialty':
                    setDentalSpecialty(value);
                    break;
                case 'specialtySchoolAttended':
                    setSpecialtySchoolAttended(value);
                    break;
                case 'yearSpecialtyCompleted':
                    setYearSpecialtyCompleted(value);
                    break;
                case 'isConsciousSedationAdministered':
                    setIsConsciousSedationAdministered(value);
                    break;
                case 'isConsciousSedationInOfficeAdministered':
                    setIsConsciousSedationInOfficeAdministered(value);
                    break;
                case 'ivImSedationAdministeredName':
                    setIvImSedationAdministeredName(value);
                    break;
                case 'ivImSedationLicenseNumber':
                    setIvImSedationLicenseNumber(value);
                    break;
                case 'ivImSedationSpecialty':
                    setIvImSedationSpecialty(value);
                    break;
                case 'isGeneralAnesthesiaAdministered':
                    setIsGeneralAnesthesiaAdministered(value);
                    break;
                case 'generalAnesthesiaAdministeredName':
                    setGeneralAnesthesiaAdministeredName(value);
                    break;
                case 'generalAnesthesiaLicenseNumber':
                    setGeneralAnesthesiaLicenseNumber(value);
                    break;
                case 'generalAnesthesiaSpecialty':
                    setGeneralAnesthesiaSpecialty(value);
                    break;
                case 'otherSpecialistType':
                    setOtherSpecialistType(value);
                    break;
                case 'consciousSedationAdministeredName':
                    setConsciousSedationAdministeredName(value);
                    break;
                case 'consciousSedationLicenseNumber':
                    setConsciousSedationLicenseNumber(value);
                    break;
                case 'consciousSedationSpecialty':
                    setConsciousSedationSpecialty(value);
                    break;
                case 'generalAnesthesiaDetailsAdministeredName':
                    setGeneralAnesthesiaDetailsAdministeredName(value);
                    break;
                case 'generalAnesthesiaDetailsLicenseNumber':
                    setGeneralAnesthesiaDetailsLicenseNumber(value);
                    break;
                case 'generalAnesthesiaDetailsSpecialty':
                    setGeneralAnesthesiaDetailsSpecialty(value);
                    break;
                default:
                    break;
            }
        }
    }, []);

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    const overrideProps = {
        pageHeaderTitle: {
            content: getPageTitleInfo(),
        },
        surveyHeader: {
            content: translator(messages.anesthesiarenewalSurvey),
        },
        isDentalSpecialtyCompleted: {
            value: isDentalSpecialtyCompleted,
            onValueChange: (value) => handleChange('isDentalSpecialtyCompleted', value, 'toggle'),
        },
        dentalSpecialty: {
            value: dentalSpecialty,
            onValueChange: (value) => handleChange('dentalSpecialty', value, 'input'),
        },
        specialtySchoolAttended: {
            value: specialtySchoolAttended,
            onValueChange: (value) => handleChange('specialtySchoolAttended', value, 'input'),
        },
        yearSpecialtyCompleted: {
            value: yearSpecialtyCompleted,
            onValueChange: (value) => handleChange('yearSpecialtyCompleted', value, 'input')
        },
        administeredAnestheticModalities: {
            value: administeredAnestheticModalities,
            onValueChange: (value) => handleChange('administeredAnestheticModalities', value, 'checkboxgroup'),
        },
        othersAdministerAnesthetic: {
            value: othersAdministerAnesthetic,
            onValueChange: (value) => handleChange('othersAdministerAnesthetic', value, 'checkboxgroup'),
        },

        isConsciousSedationAdministered: {
            visible: othersAdministerAnesthetic.length >= 1 && !othersAdministerAnesthetic.includes('None'),
            value: isConsciousSedationAdministered,
            onValueChange: (value) => handleChange('isConsciousSedationAdministered', value, 'toggle'),
        },
        specialistTypeAdministeringAnesthesia: {
            value: specialistTypeAdministeringAnesthesia,
            visible: isConsciousSedationAdministered === true,
            onValueChange: (value) => handleChange('specialistTypeAdministeringAnesthesia', value, 'checkboxgroup'),
        },

        isConsciousSedationInOfficeAdministered: {
            visible: isConsciousSedationAdministered === false,
            value: isConsciousSedationInOfficeAdministered,
            onValueChange: (value) => handleChange('isConsciousSedationInOfficeAdministered', value, 'toggle'),
        },

        ivImSedationAdministeredName: {
            value: ivImSedationAdministeredName,
            onValueChange: (value) => handleChange('ivImSedationAdministeredName', value, 'input'),
        },
        ivImSedationLicenseNumber: {
            value: ivImSedationLicenseNumber,
            onValueChange: (value) => handleChange('ivImSedationLicenseNumber', value, 'input'),
        },
        ivImSedationSpecialty: {
            value: ivImSedationSpecialty,
            onValueChange: (value) => handleChange('ivImSedationSpecialty', value, 'input'),
        },

        isGeneralAnesthesiaAdministered: {
            visible: isConsciousSedationInOfficeAdministered === false,
            value: isGeneralAnesthesiaAdministered,
            onValueChange: (value) => handleChange('isGeneralAnesthesiaAdministered', value, 'toggle'),
        },
        generalAnesthesiaAdministeredName: {
            value: generalAnesthesiaAdministeredName,
            onValueChange: (value) => handleChange('generalAnesthesiaAdministeredName', value, 'input'),
        },
        generalAnesthesiaLicenseNumber: {
            value: generalAnesthesiaLicenseNumber,
            onValueChange: (value) => handleChange('generalAnesthesiaLicenseNumber', value, 'input'),
        },
        generalAnesthesiaSpecialty: {
            value: generalAnesthesiaSpecialty,
            onValueChange: (value) => handleChange('generalAnesthesiaSpecialty', value, 'input'),
        },

        specialtyGroup: {
            visible: isDentalSpecialtyCompleted === true,
        },
        generalAnesthesiaSpecialtyGroup: {
            visible: isGeneralAnesthesiaAdministered === true,
        },
        ivImSedationSpecialtyGroup: {
            visible: isConsciousSedationInOfficeAdministered === true,
        },
        surveyContainer: {
            visible: !formSubmitted && !_.isEmpty(renewalPolicy)
        },
        confirmationContainer: {
            visible: formSubmitted || _.isEmpty(renewalPolicy)
        },
        tncCheckbox: {
            value: renewalAcknowledged,
            onValueChange: handleRenewalAgreeChange
        },
        tncCheckbox2ca: {
            visible: userState === 'CA',
        },
        submitButton: {
            disabled: buttonDisabled,
        },
        otherSpecialistType: {
            visible: specialistTypeAdministeringAnesthesia.includes('Other specialist'),
            value: otherSpecialistType,
            onValueChange: (value) => handleChange('otherSpecialistType', value, 'input'),
        },
        confirmationInfo: {
            value: getConfirmationInfo()
        },
        consciousSedationDetailsGroup: {
            visible: othersAdministerAnesthetic.includes('Conscious sedation (including IV or IM) in office') && !othersAdministerAnesthetic.includes('None'),
        },
        consciousSedationAdministeredName: {
            value: consciousSedationAdministeredName,
            onValueChange: (value) => handleChange('consciousSedationAdministeredName', value, 'input'),
        },
        consciousSedationLicenseNumber: {
            value: consciousSedationLicenseNumber,
            onValueChange: (value) => handleChange('consciousSedationLicenseNumber', value, 'input'),
        },
        consciousSedationSpecialty: {
            value: consciousSedationSpecialty,
            onValueChange: (value) => handleChange('consciousSedationSpecialty', value, 'input'),
        },
        generalAnesthesiaDetailsGroup: {
            visible: othersAdministerAnesthetic.includes('General anesthesia in office') && !othersAdministerAnesthetic.includes('None'),
        },
        generalAnesthesiaDetailsAdministeredName: {
            value: generalAnesthesiaDetailsAdministeredName,
            onValueChange: (value) => handleChange('generalAnesthesiaDetailsAdministeredName', value, 'input'),
        },
        generalAnesthesiaDetailsLicenseNumber: {
            value: generalAnesthesiaDetailsLicenseNumber,
            onValueChange: (value) => handleChange('generalAnesthesiaDetailsLicenseNumber', value, 'input'),
        },
        generalAnesthesiaDetailsSpecialty: {
            value: generalAnesthesiaDetailsSpecialty,
            onValueChange: (value) => handleChange('generalAnesthesiaDetailsSpecialty', value, 'input'),
        },
        consciousSedationAdministeredBy: {
            content: (
                <span>
                    Please indicate who administers
                    {' '}
                    <span style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
                        conscious sedation
                    </span>
                    {' '}
                    (including IV or IM) in office:
                </span>
            )
        },
        generalAnesthesiaDetailsAdministeredBy: {
            content: (
                <span>
                    Please indicate who administers
                    {' '}
                    <span style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
                        general anesthesia
                    </span>
                    {' '}
                    (including IV or IM) in office:
                </span>
            )
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            handleSubmitClick,
            handleCloseClick
        }
    };

    return renderContentFromMetadata(metadata.pageContent, overrideProps, resolvers);
}

export default withRouter(withApplicationPropertyContext(PLRenewalSurveyQuestionnaire));
